<template>
  <div
    class="layout__component-container-wrap layout__component-container-wrap--dark layout--padding-bottom-xl"
  >
    <div class="layout__component-container layout__component-container--dark">
      <h2 class="text-size-xl weight--bold layout--margin-bottom-xs">
        My Account
      </h2>
      <div class="account__wrap">
        <AccountMenu />
        <v-wait class="account__main-content" for="loading data">
          <spring-spinner
            :animation-duration="1500"
            :size="53"
            :color="'#b6bbff'"
            transition="fade"
            mode="out-in"
            :duration="1000"
            enter-active-class="enter-active"
            slot="waiting"
          />
          <router-view></router-view>
        </v-wait>
      </div>
    </div>
  </div>
</template>

<script>
import AccountMenu from "./AccountMenu";
import Loading from "../../components/Loading";
import { mapWaitingGetters } from "vue-wait";

export default {
  name: "Account",
  components: {
    AccountMenu,
    Loading,
  },
  methods: {},
  computed: {
    ...mapWaitingGetters("account", { data: "loading data" }),
  },
};
</script>

<style lang="scss">
@import "../../styles/pages/_account.scss";
</style>
